// ConfirmationContext.tsx
import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useMemo,
} from "react";

interface ConfirmationContextType {
  isBlocking: boolean;
  setBlocking: (value: boolean) => void;
  isActiveHeader: boolean;
  setHeader: (value: boolean) => void;
  isTabIndex: boolean;
  setTabindex: (value: boolean) => void;
}

const ConfirmationContext = createContext<ConfirmationContextType | undefined>(
  undefined
);

export const useConfigPromp = () => {
  const context = useContext(ConfirmationContext);
  if (!context) {
    throw new Error(
      "useConfirmation must be used within a ConfirmationProvider"
    );
  }
  return context;
};

interface ConfirmationProviderProps {
  children: ReactNode;
}

const PrompConfigProvider: React.FC<ConfirmationProviderProps> = ({
  children,
}) => {
  const [isBlocking, setIsBlocking] = useState<boolean>(false);
  const [isActiveHeader, setIsActiveHeader] = useState<boolean>(true);
  const [isTabIndex, setIsTabIndex] = useState<boolean>(true);

  const setBlocking = (value: boolean) => {
    setIsBlocking(value);
  };

  const setHeader = (value: boolean) => {
    setIsActiveHeader(value);
  };

  const setTabindex = (value: boolean) => {
    setIsTabIndex(value);
  };

  const value = useMemo(
    () => ({
      isBlocking,
      setBlocking,
      isActiveHeader,
      setHeader,
      isTabIndex,
      setTabindex,
    }),
    [isBlocking, isActiveHeader, isTabIndex]
  );
  return (
    <ConfirmationContext.Provider value={value}>
      {children}
    </ConfirmationContext.Provider>
  );
};

export default PrompConfigProvider;
